import { useMemo } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const MASK_INITIAL = { y: "115%" };
const MASK_ANIMATE = { y: 0 };
const LEAD_INITIAL = { opacity: 0, y: 16 };
const LEAD_ANIMATE = { opacity: 1, y: 0 };
const LEAD_TRANSITION = { duration: 0.8, delay: 0.45, ease: EASE };

const MaskedLine = ({ children, delay = 0 }) => {
  const transition = useMemo(() => ({ duration: 0.9, delay, ease: EASE }), [delay]);
  return (
    <span className="block overflow-hidden pb-1">
      <motion.span
        className="block"
        initial={MASK_INITIAL}
        animate={MASK_ANIMATE}
        transition={transition}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const PageHero = ({ kicker, title, lead, testId }) => (
  <section
    data-testid={testId}
    className="relative overflow-hidden border-b border-[#C59B4B]/50 bg-gradient-to-b from-[#EBD9F7] via-[#F7ECD9] to-[#F6E0EC]"
  >
    <div
      className="warm-halo pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[760px] -translate-x-1/2 rounded-full"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-4xl px-5 py-20 text-center sm:px-8 sm:py-28">
      <MaskedLine delay={0.05}>
        <span className="text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-[#9E7B35]">
          {kicker}
        </span>
      </MaskedLine>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-[#101826] leading-[1.12]">
        <MaskedLine delay={0.15}>{title}</MaskedLine>
      </h1>
      {lead && (
        <motion.p
          initial={LEAD_INITIAL}
          animate={LEAD_ANIMATE}
          transition={LEAD_TRANSITION}
          className="mx-auto mt-6 max-w-2xl text-lg sm:text-xl leading-relaxed text-[#3D4958]"
        >
          {lead}
        </motion.p>
      )}
    </div>
  </section>
);
